import {
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Visibility as ViewIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Update as UpdateIcon,
  PersonAdd as OnboardIcon,
  ChatOutlined as ChatOutlinedIcon,
  CurrencyExchange as CurrencyExchangeIcon,
} from "@mui/icons-material";

import { ONBOARDING_STATUS, TABLE_TYPES } from "../config/tableConfig";
import { useAuth } from "../../../contexts/AuthContext";

const ActionBar = ({
  open,
  anchorEl,
  onClose,
  onView,
  onEdit,
  onAllUpdate,
  onDelete,
  isUpdating,
  onOnboard,
  onPreOnboardDoc,
  rowData,
  tableType,
  onUpdateData,
  onLeadFeedback,
  onCrifReport,
  onFinancierChangeRequest,
}) => {
  const { isAdmin, isDealer, isOnboarding, isPreOnboarding } = useAuth();

  const isLead = Boolean(rowData?.leadId);

  const anchorPosition = anchorEl
    ? {
        top: anchorEl.getBoundingClientRect().bottom + 8,
        left: anchorEl.getBoundingClientRect().left,
      }
    : { top: 0, left: 0 };

  const isLeadUpdate = tableType === TABLE_TYPES.LEADS && isDealer;

  const isPreOnboardingUpdate =
    tableType === TABLE_TYPES.PRE_ONBOARDING &&
    (isAdmin || isPreOnboarding || isOnboarding);

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          sx: { mt: 0.5 },
        },
      }}
    >
      <MenuItem onClick={onView} disabled={isUpdating}>
        <ListItemIcon>
          <ViewIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>View</ListItemText>
      </MenuItem>

      {isLeadUpdate && (
        <MenuItem
          onClick={() => onUpdateData(rowData?.leadId)}
          disabled={
            isUpdating ||
            (rowData?.status === "SOFT_APPROVED" &&
              rowData?.loanSummary?.financier &&
              !rowData?.isFinancierChangeRequest)
          }
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Update</ListItemText>
        </MenuItem>
      )}

      {isPreOnboardingUpdate && (
        <MenuItem
          onClick={() => onAllUpdate(rowData?.prn)}
          disabled={rowData?.status === "Approved"}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Update</ListItemText>
        </MenuItem>
      )}

      {tableType === TABLE_TYPES.LEADS && (
        <MenuItem onClick={() => onLeadFeedback(rowData?.leadId)}>
          <ListItemIcon>
            <ChatOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Feedback</ListItemText>
        </MenuItem>
      )}

      {tableType === TABLE_TYPES.LEADS && isAdmin && (
        <MenuItem
          onClick={() => onCrifReport(rowData?.leadId)}
          disabled={
            rowData?.status === "SOFT_APPROVED" &&
            !rowData?.isFinancierChangeRequest
          }
        >
          <ListItemIcon>
            <ChatOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Crif Report</ListItemText>
        </MenuItem>
      )}

      {tableType === TABLE_TYPES.PRE_ONBOARDING && !isLead && (
        <MenuItem
          onClick={onOnboard}
          disabled={isUpdating || rowData?.status !== "Approved"}
        >
          <ListItemIcon>
            <OnboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Onboard</ListItemText>
        </MenuItem>
      )}

      {tableType === TABLE_TYPES.PRE_ONBOARDING && isLead && (
        <MenuItem
          onClick={onFinancierChangeRequest}
          disabled={rowData?.status === "Approved"}
        >
          <ListItemIcon>
            <CurrencyExchangeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Change Financier</ListItemText>
        </MenuItem>
      )}

      {tableType === TABLE_TYPES.PRE_ONBOARDING && (
        <MenuItem onClick={onEdit} disabled={isUpdating}>
          <ListItemIcon>
            <UpdateIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Update Status</ListItemText>
        </MenuItem>
      )}

      {tableType === TABLE_TYPES.LEADS && !isDealer && (
        <MenuItem
          onClick={() => onPreOnboardDoc(rowData?.leadId)}
          disabled={
            rowData?.status === "APPROVED" ||
            rowData?.preOnboardingId ||
            rowData?.prn
          }
        >
          <ListItemIcon>
            <OnboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Pre-Onboard</ListItemText>
        </MenuItem>
      )}

      {/* <Divider /> */}

      {/* {!isDealer && tableType === TABLE_TYPES.LEADS ? null : (
        <MenuItem onClick={onDelete} disabled={isUpdating}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Delete</ListItemText>
        </MenuItem>
      )} */}
    </Menu>
  );
};

export default ActionBar;
